import React from 'react'
import Isvg from 'react-inlinesvg'
import Footer from '../Footer'
import moment from 'moment'
import './Article.scss'

import iconFacebook from '../../sass/icons/icon-facebook-f.svg'
import iconTwitter from '../../sass/icons/icon-twitter.svg'
import iconLinkedIn from '../../sass/icons/icon-linkedin.svg'

const formatDateText = timestamp => {
    const date = moment(timestamp);
    return date.format('DD/MM/YYYY [às] HH:MM [por]')
}

const share = url => {
    const windowWidth = 
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth

    const windowHeight = 
        window.innerHeight ||
        document.documentElement.clientHeight || 
        document.getElementsByTagName('body')[0].clientHeight

    const width  = 575,
          height = 400,
          left   = (windowWidth  - width)  / 2,
          top    = (windowHeight - height) / 2,
          opts   = 'status=1' +
                 ',width='  + width  +
                 ',height=' + height +
                 ',top='    + top    +
                 ',left='   + left;

    window.open(url, 'compartilhar', opts);

    return false;
}

const Article = ({ article }) => {
    return (
        <div>
            <div className="blog-article">
                <header className="blog-header">
                    <div className="container">
                        <div className="grid-center">
                            <div className="col-10_xs-12">
                                <h1>{article.title}</h1>
                                <p> {article.content_preview}</p>
                            </div>
                        </div>
                    </div>
                </header>
                <section className="details">
                    <div className="container">
                        <div className="grid-spaceBetween">
                            <div className="col-4_xs-12 date">
                                <p>{formatDateText(article.created_at)}<span>{article.author_name}</span></p>
                            </div>
                            <div className="col-4_xs-12 social">
                                <p>compartilhe</p>
                                <ul className="share-links">
                                    <li>
                                        <a onClick={(e) => { e.preventDefault(); share(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`); }} href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}>
                                            <Isvg className="facebook" src={iconFacebook} />
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={(e) => { e.preventDefault(); share('http://twitter.com/share')}} href="http://twitter.com/share">
                                            <Isvg className="twitter" src={iconTwitter} />
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={(e) => { e.preventDefault(); share(`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`)}} href={`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`}>
                                            <Isvg className="linkedin" src={iconLinkedIn} />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="cover">
                    <div className="container">
                        <div className="grid">
                            <div className="col-12">
                                <figure>
                                    <img src={article.image} alt={article.caption}/>
                                    <figcaption>
                                        {article.caption}
                                    </figcaption>
                                </figure>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container">
                        <div className="grid">
                            <div className="col-12" dangerouslySetInnerHTML={ {__html: article.content} }>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Article


// WEBPACK FOOTER //
// ./src/components/Article/index.js